import Button from "components/button";
import ButtonIcon from "components/button-icon";
import DateRangerPicker from "components/date-range-picker";
import { IconFilterActive } from "components/icons/icn-filter-active.icon";
import { IconFilterInactive } from "components/icons/icn-filter-inactive.icon";
import { SelectWithSearchAndSelectAll } from "components/select-with-search-select-all";
import type React from "react";
import intl from "react-intl-universal";
import { ButtonWrapper, FilterWrapper } from "../styled";
import type { NotificationsToolbarProps, StatusOption } from "../types";

const getStatusOptions = (): StatusOption[] => [
  {
    Id: 1,
    Description: intl.get("masterdataAutomationNotifications.status.success"),
  },
  {
    Id: 2,
    Description: intl.get("masterdataAutomationNotifications.status.error"),
  },
];

const NotificationsToolbar: React.FC<NotificationsToolbarProps> = ({
  processingStatuses,
  minCreatedDate,
  maxCreatedDate,
  hasActiveFilters,
  onStatusChange,
  onDateChange,
  onApplyFilters,
  onExportToCsv,
  onClearFilters,
}) => {
  const getIconFilter = () =>
    hasActiveFilters ? (
      <span data-testid="icon-filter-active">
        <IconFilterActive />
      </span>
    ) : (
      <span data-testid="icon-filter-inactive">
        <IconFilterInactive />
      </span>
    );

    const restClearFilters = {
    "data-testid": "btn-apply-filters",
  };

  const restExportToCsv = {
    "data-testid": "btn-export-csv",
  };

  return (
    <FilterWrapper>
      <SelectWithSearchAndSelectAll
        label={intl.get("masterdataAutomationNotifications.table.type")}
        options={getStatusOptions()}
        onChange={onStatusChange}
        values={processingStatuses}
        valueField="Id"
        labelField="Description"
        style={{ background: "var(--color-contrast-white)", height: "40px" }}
        hideSelectAll
        limitOptions={100}
        mainStyle={{zIndex: 4}}
      />

      <DateRangerPicker
        title={intl.get("commons.period")}
        dataDe={minCreatedDate}
        dataAte={maxCreatedDate}
        handleChange={onDateChange}
      />

      <ButtonWrapper>
        <Button
          value={intl.get("masterdataAutomationNotifications.toolbar.exportToCsv")}
          onClick={onExportToCsv}
          className="btn-export"
          {...restExportToCsv}
        />
        <Button
          value={intl.get("masterdataAutomationNotifications.toolbar.clearFilters")}
          onClick={onClearFilters}
          className="btn-clear-filters"
          {...restClearFilters}
        />
        <ButtonIcon
          buttonType="primary"
          buttonText={intl.get("filters.generalFilter")}
          onClick={onApplyFilters}
          buttonIcon={getIconFilter()}
          className="btn-filter"
        />
      </ButtonWrapper>
    </FilterWrapper>
  );
};

export default NotificationsToolbar;
